import {isLocalhost} from './registerServiceWorker'

export const DEBUG = isLocalhost
// export const DEBUG = process.env.NODE_ENV === 'development' ? true : false
export const BASE_URL  = DEBUG ? 'http://localhost:8080' : 'https://api.dicidio.com'
export const WEB_BASE_URL = DEBUG ? 'http://localhost:3000' : 'https://apps.dicidio.com'
export const VERSION = process.env.REACT_APP_VERSION
export const APPNAME = process.env.REACT_APP_NAME
export const GOOGLE_CLIENT_ID = "163017945869-o002j56ulhdhvbnp0i1if0bs4on9mger.apps.googleusercontent.com"


// WEBPACK FOOTER //
// ./src/constants.js